import React from "react";

import '../style/HomePageFooter.css';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const HomePageFooter = (props) => {
  return (
    <section className="hero is-dark home-page-footer">
      <div className="container">
        Thanks for visiting!
      </div>
    </section>
  );
};

export default HomePageFooter;